import { BaseService } from '../../infra/base.service'
import type { AgendaNotesRepository } from './agenda-notes.repository'
import type { AgendaNoteEntity, AgendaNoteInput } from './agenda-note.entity'

export class AgendaNotesService extends BaseService<AgendaNoteEntity> {
    constructor(private rep: AgendaNotesRepository) {
        super(rep)
    }

    findForRange(from: string, to: string) {
        return this.rep.findForRange(from, to)
    }

    createNote(input: AgendaNoteInput & { date: string }) {
        return this.rep.createNote(input)
    }

    updateNote(agendaNoteId: string, input: Partial<AgendaNoteInput>) {
        return this.rep.updateNote(agendaNoteId, input)
    }

    removeNote(agendaNoteId: string) {
        return this.rep.removeNote(agendaNoteId)
    }

    skipDay(agendaNoteId: string, day: string) {
        return this.rep.skipDay(agendaNoteId, day)
    }

    endBeforeDay(agendaNoteId: string, day: string) {
        return this.rep.endBeforeDay(agendaNoteId, day)
    }

    complete(agendaNoteId: string, day: string) {
        return this.rep.complete(agendaNoteId, day)
    }

    uncomplete(agendaNoteId: string, day: string) {
        return this.rep.uncomplete(agendaNoteId, day)
    }
}
